"use client"

import { motion } from "framer-motion"
import type { LucideIcon } from "lucide-react"

interface ServiceCardProps {
  icon: LucideIcon
  title: string
  description: string
  features?: string[]
  index?: number
}

export const ServiceCard = ({ icon: Icon, title, description, features, index = 0 }: ServiceCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="group h-full rounded-2xl border border-slate-200 bg-white p-6 shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl sm:p-8"
    >
      <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-teal-500 to-teal-600 text-white transition-transform duration-300 group-hover:scale-110 sm:h-16 sm:w-16">
        <Icon size={28} />
      </div>
      <h3 className="mb-3 text-lg font-bold text-slate-900 sm:mb-4 sm:text-xl">{title}</h3>
      <p className="mb-4 text-sm text-slate-600 sm:text-base">{description}</p>
      {features && (
        <ul className="space-y-2">
          {features.map((feature, idx) => (
            <li key={idx} className="flex items-start space-x-2 text-xs text-slate-600 sm:text-sm">
              <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-teal-600"></span>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      )}
    </motion.div>
  )
}

export default ServiceCard
